import React, { useEffect, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { AxiosResponse } from 'axios';
import { useForm } from 'react-hook-form';

import schema from './utils/schema';

import { deleteAccountByGroup, editAccountByGroup } from 'RestAPIs/admin';

import AccountsInner from './components/AccountsInner';

import { useGetAccountsByGroup } from '../../../../../../../../../queries';
import { TabProps } from '../../types';

const Accounts: React.FC<TabProps> = ({
  setIsNavigationDisabled,
  rows,
  toggleInnerLayout,
  currentViewData,
  setCurrentViewData,
  setIsDirty
}) => {
  const [deletedIds, setDeletedIds] = useState<number[]>([]);

  const methods = useForm({
    defaultValues: schema.cast({ accounts: [] }),
    resolver: yupResolver(schema)
  });

  const { data: accounts, isFetching } = useGetAccountsByGroup(
    currentViewData.groupId
  );

  useEffect(() => {
    if (accounts) {
      methods.reset(schema.cast({ accounts: accounts }));
    }
  }, [accounts, currentViewData]);

  const handleSubmit = (data) => {
    if (data.accounts) {
      const requestsArray: Promise<AxiosResponse>[] = [];
      data.accounts
        .filter((value) => value.isCommitted)
        .forEach((detail) => {
          requestsArray.push(
            editAccountByGroup(currentViewData.groupId, detail.accountId, {
              ...detail,
              groupId: currentViewData.groupId
            })
          );
        });
      deletedIds.forEach((id) => {
        requestsArray.push(deleteAccountByGroup(currentViewData.groupId, id));
      });

      return Promise.all(requestsArray);
    }

    return Promise.resolve();
  };

  const handleOnCancel = () => {
    setDeletedIds([]);
    methods.reset();
  };
  return (
    <AccountsInner
      setIsNavigationDisabled={setIsNavigationDisabled}
      toggleInnerLayout={toggleInnerLayout}
      rowData={currentViewData}
      rows={rows}
      methods={methods}
      onSubmit={handleSubmit}
      currentViewData={currentViewData}
      setCurrentViewData={setCurrentViewData}
      isFetching={isFetching}
      accounts={accounts}
      setDeletedIds={setDeletedIds}
      onCancel={handleOnCancel}
      setIsDirty={setIsDirty}
    />
  );
};

export default Accounts;
